import { useCallback, useEffect, useState } from 'react'
import { testChannelApi, type TestChannelState } from '../lib/settingsApi.js'

const POLL_MS = 5_000

/** État partagé du canal de test, relu toutes les 5 s et après chaque geste. */
export function useTestChannelState(channelId: string | null) {
  const [state, setState] = useState<TestChannelState | null>(null)
  const refresh = useCallback(async () => {
    if (!channelId) return
    try { setState(await testChannelApi.state(channelId)) } catch { /* garde l'état connu */ }
  }, [channelId])
  useEffect(() => {
    void refresh()
    const timer = setInterval(() => { if (!document.hidden) void refresh() }, POLL_MS)
    return () => clearInterval(timer)
  }, [refresh])
  return { state, setState, refresh }
}

